import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Home.css";
import Call from "../images/telephone.png";
import Email from "../images/email.png";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToContact) {
      document.getElementById("ContactUs")?.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <section id="ContactUs" className="contact-section">
      <div className="contact-container">
        {/* Left Side */}
        <div className="contact-left">
          <div className="overlay"></div>

          <h2>Contact Us</h2>

          <div className="contact-card">
            <div className="contact-item">
              <img src={Call} alt="Phone" />
              <span>07476 108868</span>
            </div>

            <div className="contact-item">
              <img src={Email} alt="Email" />
              <span>Simon@totalcareadvisory.com</span>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="contact-right">
          <h2>Contact Us</h2>

          <form className="contact-form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <input type="tel" placeholder="Phone" />
            <textarea placeholder="Message"></textarea>

            <button type="submit" className="animated-btn">
              <span>Submit</span>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;



































// import { useLocation } from "react-router-dom";
// import { useEffect } from "react";
// import "./Home.css";
// import Call from '../images/telephone.png'
// import Email from '../images/email.png'

// const Contact = () => {

//   useEffect(() => {
//     if (location.state?.scrollToContact) {
//       document.getElementById("ContactUs")?.scrollIntoView({
//         behavior: "smooth",
//       });
//     }
//   }, [location]);


  
//   return (
//      <section id="ContactUs" className="contact-section">
//       <div className="contact-container">
//         {/* Left Side */}
//         <div className="contact-left">
//           <div className="overlay"></div>

//           <h2>Contact us</h2>

//           <div className="contact-card">
//             <div className="contact-item">
//                 <img src={Call}/>
//               <span>07476 108868</span>
//             </div>

//             <div className="contact-item">
//                 <img src={Email}/>
//               <span>Simon@totalcareadvisory.com</span>
//             </div>

//             {/* <div className="contact-item">
//                 <img src={Location}/>
//               <span>654 Sycamore Avenue, Meadowville, WA 76543</span>
//             </div> */}
//           </div>
//         </div>

//         {/* Right Side */}
//         <div className="contact-right">
//           <h2>Contact us</h2>

//           <form className="contact-form">
//             <input type="text" placeholder="Name" />
//             <input type="email" placeholder="Email" />
//             <input type="tel" placeholder="Phone" />
//             <textarea placeholder="Message"></textarea>
//             <button className="animated-btn">
//                <span>Submit</span>
//               </button>
//           </form>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;